import React, { PropsWithChildren, useContext } from "react";
import { matchPath } from "react-router-dom";
import cx from "classnames";
import NavItem from "../NavItem";
import { NavItemProps } from "../NavItem/NavItem";
import NavThemeContext, { ThemeContextValues } from "../NavThemeContext";
import { dataTestIds } from "data-testids";

interface Props extends NavItemProps {
  nestedPaths?: string[];
}

const LeftHandNavItem = ({
  nestedPaths,
  children,
  ...props
}: PropsWithChildren<Props>) => {
  const theme = useContext(NavThemeContext);
  const path = window.location.pathname;
  const to = props?.to || "";

  const paths = nestedPaths ? [to, ...nestedPaths] : [to];
  const isMatchPath = paths.some((p) =>
    matchPath({ path: p, end: true }, path)
  );

  const isActive = !to && !nestedPaths ? false : isMatchPath;

  const navItemClass = cx(
    "relative before:block before:w-1 before:left-0 before:top-0 before:h-full before:absolute",
    {
      "before:bg-color-user-cd": theme === ThemeContextValues.Cd && isActive,
      "before:bg-color-user-agent":
        theme === ThemeContextValues.Agent && isActive,
      "before:bg-color-user-performer":
        theme === ThemeContextValues.Performer && isActive,
      "before:bg-color-user-filmmakers":
        theme === ThemeContextValues.Filmmakers && isActive,
      "before:bg-color-neutral-two":
        theme === ThemeContextValues.Default && isActive,
      "bg-color-neutral-three": isActive,
    }
  );

  return (
    <NavItem
      {...props}
      className={navItemClass}
      data-testid={
        props.isSubNav
          ? dataTestIds.componentLibrary[
              "Organisms.NavigationHeader.SubNavigationItem.subNavigationLink"
            ]
          : dataTestIds.componentLibrary[
              "Organisms.NavigationHeader.MainNavigationItem.mainNavigationLink"
            ]
      }
    >
      {children}
    </NavItem>
  );
};

export default LeftHandNavItem;
